import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Ship from "../Asset/Ship.svg";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import {
  getShipManagementList,
  getShipManagementDetails,
  getShipEquipmentDetails,
} from "../Actions/ShipManagementAPI";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import Modal from "react-bootstrap/Modal";
import userRoles from "../helpers/role";
import { MdReport } from "react-icons/md";
import { getMMPLShipInfo } from "../Actions/MMPLDashboardAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import {
  downloadServiceRequest,
  downloadShipEquipmentStatus,
} from "../Actions/ShipEquipmentDetailsAPI";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import moment from "moment";
import $ from "jquery";

let user = localStorage.getItem("UserRoles");

class GrandAdminShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      RemarkmodalIsOpen: false,
      Records: [],
      EditAll: false,
      isShip: false,
      isShore: false,
      isBoth: false,
    };
  }

  // componentDidMount() {
  //   console.log($("div#popup-trigger").data("item"), "Item");
  //   window.addEventListener('click', function (e) {
  //     console.log($(e.target).attr('id'))
  //     if (document.getElementById('popup-trigger').contains(e.target)) {
  //       alert("inside");
  //     } else {
  //       alert("Outside");
  //     }
  //   });
  // }

  renderPopover(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.DownloadStatus")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }

  renderbudgetover(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.BudgetListScreen")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderShipDetails(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}> {t("PendingShipScreenContent.ViewShipDetails")} </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderMoreDetails(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.MoreInformation")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderEquipmentDetails(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("PendingShipScreenContent.ViewEquipmentDetails")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }

  renderAddEquipmentDetails(props) {
    const{t}=this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
          {t("PendingShipScreenContent.AddorEditEquipmentDetails")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const {
      arraylist,
      pageSize,
      shipMMPLInfo,
      totalRecords,
      MMPLShipInfo,
      showEquipmentDetails,
      t
    } = this.props;
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("DashboardMoreInformation.MoreInformation")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: "100%" }}>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipContactNumber1")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipContactNumber1 : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipContactNumber2")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipContactNumber2 : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.SuperintendentEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.superintendentEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.SuperintendentPhone")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.superintendentPhone : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.FleetManagerEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.fleetManagerEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.TechnicalExecutiveEmail")}</th>
                <td>
                  {MMPLShipInfo ? MMPLShipInfo.technicalExecutiveEmail : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.VesselGroupEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.vesselGroupEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.CompanyDetails")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.companyDetails : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.InvoiceForwardingEmail")}</th>
                <td>
                  {MMPLShipInfo ? MMPLShipInfo.invoiceForwardingEmail : ""}
                </td>
              </tr>
            </table>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.RemarkmodalIsOpen}
          onHide={() => this.setState({ RemarkmodalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "rgb(26, 52, 100)", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("DashboardShipReports.ShipReports")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: "100%" }}>
              {this.state.Records && this.state.Records.length != 0 ? (
                <tbody>
                  {this.state.Records?.map((item, index) => {
                    return (
                      <div>
                        <div className="row">
                          <div className="col7" style={{ paddingLeft: 15 }}>
                            {index + 1}.
                          </div>
                          <div className="col-sm-6">
                            <span>
                              <strong>{t("DashboardShipReports.Title")} : </strong>
                              <span> {item?.title} </span>
                            </span>
                          </div>
                          <div className="col-sm-5">
                            <span>
                              <strong>{t("DashboardShipReports.Date")} : </strong>
                              <span>
                                {item?.date
                                  ? moment(item.date).format("DD MMM YYYY")
                                  : ""}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 paddingcard">
                            <span>
                              <strong>{t("DashboardShipReports.Remarks")} : </strong>{" "}
                            </span>
                          </div>
                          <div className="col-sm-12 paddingcard">
                            <span> {item?.remark} </span>
                          </div>
                        </div>
                        <br />
                      </div>
                    );
                  })}
                </tbody>
              ) : (
                <center>
                  <span>{t("CommonText.NoReport")}</span>
                </center>
              )}
            </table>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}

        {arraylist.data.length != 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="container">
              <h6 className="resource-list-title no-item-card">
              {t("CommonText.NoItem")}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1, 2);
  }
  getShipRemark(item) {
    this.setState({ RemarkmodalIsOpen: true, Records: item });
  }

  getShipMMPLInfo(item) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipInfo(item));
    this.setState({ modalIsOpen: true });
  }

  toggle = (target, item) => {
    this.setState({
      [target]: !this.state[target],
      ship: false,
      shore: false,
      both: false,
    });
  };

  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "ship") {
      this.state.isShip = true;
      this.state.isShore = false;
      this.state.isBoth = false;
    }
    if (nodeName === "shore") {
      this.state.isShip = false;
      this.state.isShore = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.isShip = false;
      this.state.isShore = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };

  renderCardData = () => {
    const {
      showSidePane,
      arraylist,
      isServiceDetail,
      showEquipmentDetails,
      showMMPLDetailsPane,
      t
    } = this.props;
    return arraylist.data && arraylist.data.length
      ? arraylist.data.map((item, index) => {
          return (
            <div
              className="card mb-1"
              style={{ overflow: "hidden", position: "relative" }}
            >
              {/* {item.isContainAboveThreshold ? (
              <div className="arrow-left-red"></div>
            ) : (
                <div className="arrow-left-green"></div>
              )} */}

              <div className="p-3">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div
                      className={
                        showSidePane
                          ? `col-sm-10 col-md-10 col-10 col-m-auto`
                          : `col-sm-10 col-md-10 col-10 col-m-auto`
                      }
                    >
                      <div className="row px-3">
                        <div
                          className={
                            showSidePane
                              ? "col-sm-12 col-md-12 mb-1"
                              : "col-sm-5 col-md-5"
                          }
                        >
                          <h6
                            className="resource-list-title m-0"
                            onClick={() => this.ShowSidePanel(item.shipId)}
                          >
                            {item.shipName !== "" ? item.shipName : ""}
                          </h6>
                        </div>

                        <div
                          className={
                            showSidePane
                              ? "tip_data col-sm-12"
                              : "tip_data col-sm-7"
                          }
                          id="popup-trigger"
                          // data-items={item.shipId}
                          onClick={() => this.setPopup(item.shipId)}
                          // // onMouseDown={() => this.setPopup2()}
                          >
                          <span>
                            <strong>{t("content.Destination")}: </strong>
                            <i aria-hidden="true"></i>
                            <span className="lato">
                              {item.destination ?? "Destination"}
                            </span>
                          </span>
                          <strong> | </strong>
                          <span>
                            <strong> {t("content.ETA")}: </strong>
                            <i aria-hidden="true"></i>
                            <span className="lato ">
                              {item.eta
                                ? moment(item.eta).format("DD MMM YYYY")
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? "col-sm-6 mb-1"
                              : "col-sm-3 col-lg-3 col-md-3"
                          }
                        >
                          <span>
                            <strong>{t("content.TotalEquipment")}: </strong>
                            <span className="lato ">
                              {item.total ? item.total : 0}
                            </span>
                          </span>
                        </div>

                        <div
                          className={
                            showSidePane
                              ? "col-sm-6 mb-1"
                              : "col-sm-3 col-lg-3 col-md-3"
                          }
                        >
                          <span>
                            <strong>{t("content.IMOno")}: </strong>
                            <span className="lato">
                              {item?.imo ? item?.imo : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? "col-sm-6 mb-1"
                              : "col-sm-3 col-lg-3 col-md-3"
                          }
                        >
                          <span>
                            <strong>{t("TopPaneContent.TypeofShip")}: </strong>

                            <span className="lato ">
                              {item.typeofShip ? item.typeofShip : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? "col-sm-6 mb-1"
                              : "col-sm-3 col-lg-3 col-md-3"
                          }
                        >
                          <span>
                            <strong>{t("EquipmentServiceTypes.Status")}: </strong>
                            {item && item?.status === "Pending" ? (
                              <button className="pending-button italicFont">
                                {item.status ? item.status : ""}
                              </button>
                            ) : item && item?.status === "Draft" ? (
                              <button className="draft-button italicFont">
                                {item.status ? item.status : ""}
                              </button>
                            ) : item && item?.status === "Waitingforapproval" ? (
                              <button className="waiting-button italicFont">
                                  {item.status ? "Waiting for approval" : ""}
                              </button>
                            ):("")}
                          </span>
                        </div>
                        <div
                          className={
                            showSidePane
                              ? "col-sm-12 mb-1 mt-1"
                              : "col-sm-12 col-lg-12 col-md-12 mt-1"
                          }
                        >
                          <span>
                            <strong>{t("PendingShipScreenContent.Remark")}: </strong>
                            <span className="lato ">
                              {item.remarks ? item.remarks : ""}
                            </span>
                          </span>
                        </div>

                      </div>
                    </div>
                    <div
                      className={
                        showSidePane
                          ? `col-sm-2 col-md-2 col-lg-2 col-m-auto text-center`
                          : `col-sm-2 col-md-2 col-lg-2  col-2 col-m-auto text-center`
                      }
                    >
                      <div className="col-sm-12">
                        <div
                          className="ml0"
                          style={
                            showEquipmentDetails
                              ? { marginLeft: "1rem", marginTop: "2rem" }
                              : { marginLeft: "1.5rem", marginTop: "1rem" }
                          }
                        >
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderAddEquipmentDetails()}
                          >
                            <i
                              className="fa fa-eye click px-1"
                              aria-hidden="true"
                              onClick={() =>
                                this.ViewEquipmentDetails(item.shipId)
                              }
                              style={{
                                color: " #1a3464",
                                fontSize: "1.8rem",
                              }}
                            ></i>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : null;
  };

  downloadDocument(shipId, shipName) {
    const { dispatch } = this.props;
    dispatch(downloadShipEquipmentStatus(shipId, shipName));
  }

  submitRequest = (item) => {
    const { dispatch } = this.props;
    dispatch(downloadServiceRequest(item, this.state));
  };

ViewEquipmentDetails = (shipId) => {
    const { dispatch } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/GrandAdmin/PendingShipDetails/${shipId}`);
    dispatch(getShipEquipmentDetails(shipId));
    window.scrollTo(0, 0);
  };

  setPopup = (shipId) => {
    this.props.dispatch({ type: "MapPopup", data: shipId });
  };
  // setPopup2 = () => {
  //   this.props.dispatch({ type: "MapPopup", data: 0 });
  // };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    isServiceDetail: state.ServiceUpdateReducer.IsServiceUpdate || false,
    MMPLShipInfo: state.MMPLDashboardReducer.MMPLShipInfo,
    showEquipmentDetails: state.SidePanReducer.ShowEquipmentDetails || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrandAdminShipCard)
));
